import React, { Component } from "react";
import QuoteStepBase, { getDriverStepMapDispatch, mapDriverStepProps } from '../components/QuoteStepBase'
import Question from '../components/Question'
import { Card, InputGroup, Button, Form, FormControl } from 'react-bootstrap'
import ButtonContinue from "../components/ButtonContinue";
import { IDriverStepProps, IQuoteStepState } from "../components/interfaces";
import { PATHS, QUOTE_STEPS, COMPONENTS, QUOTE_QUESTIONS } from "../AppConstants";
import { connect } from "react-redux";
import { validationUtils } from "../validation/Validation";
import QuoteStep from "./QuoteStepLayout";
import { ValidatableForm } from "../components/ValidatableForm";
import { ValidatableFormGroup } from "../components/ValidatableFormGroup";
import Utilities from "../classes/Utilities";

interface IState extends IQuoteStepState {
    validLicense: string,
    currentLicenseStatus: string,
    licenseYears: string,
    driverTrainingClasses: string,
    visibleCurrentStatus: boolean,
    visibleFirstLicense: boolean;
}

class YourLicense extends QuoteStepBase<IDriverStepProps, IState> {
    constructor(props: IDriverStepProps) {
        super(props);
        this.next = this.next.bind(this);

        this.state = {
            validLicense: QUOTE_QUESTIONS.YES_NO.YES,
            currentLicenseStatus: "",
            licenseYears : "16",
            driverTrainingClasses : "",
            visibleCurrentStatus: false,
            visibleFirstLicense: true,
            updatingStore: false,
            errors: null
        };
    }

    componentDidMount() {
        super.componentDidMount();
        this.props.reportCurrentStep();
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.meta.propsSource === COMPONENTS.PROPS_SOURCES.APP_STORE) {
            const driver = nextProps.driver;
            nextProps.meta.propsSource = "";

            if (null === driver) return prevState;

            const visibleFirstLicense = !driver.validLicense || (!!driver.validLicense && driver.validLicense === QUOTE_QUESTIONS.YES_NO.YES)
                || (!!driver.currentLicenseStatus && (driver.currentLicenseStatus === QUOTE_QUESTIONS.YOUR_LICENSE.CURRENT_LICENSE_STATUS.SUSPENDED
                    || driver.currentLicenseStatus === QUOTE_QUESTIONS.YOUR_LICENSE.CURRENT_LICENSE_STATUS.VALID_COMMERCIAL_LICENSE
                    || driver.currentLicenseStatus === QUOTE_QUESTIONS.YOUR_LICENSE.CURRENT_LICENSE_STATUS.VALID_CANADIAN_LICENSE
                    || driver.currentLicenseStatus === QUOTE_QUESTIONS.YOUR_LICENSE.CURRENT_LICENSE_STATUS.EXPIRED
                    || driver.currentLicenseStatus === QUOTE_QUESTIONS.YOUR_LICENSE.CURRENT_LICENSE_STATUS.RESTRICTED));

            return {
                ...prevState,
                validLicense: !!driver.validLicense ? driver.validLicense : QUOTE_QUESTIONS.YES_NO.YES,
                visibleCurrentStatus: !!driver.validLicense ? driver.validLicense === QUOTE_QUESTIONS.YES_NO.NO : false,
                visibleFirstLicense: visibleFirstLicense,
                currentLicenseStatus: driver.currentLicenseStatus,
                licenseYears: !!driver.licenseYears ? driver.licenseYears : "16",
                driverTrainingClasses: driver.driverTrainingClasses
            };
        }

        return prevState;
    }

    next(event : React.MouseEvent<HTMLButtonElement, MouseEvent>) {
        event.preventDefault();

        this.setState({ updatingStore: true }, () => {
            const updatedDriver = {
                ...this.props.driver,
                validLicense: this.state.validLicense,
                currentLicenseStatus: this.state.currentLicenseStatus,
                licenseYears: this.state.licenseYears,
                driverTrainingClasses: this.state.driverTrainingClasses
            };

            this.props.updateAppState({ quoteUid: this.props.quoteUid, driver: updatedDriver })
                .then(() => this.props.history.push(Utilities.formatUrl(PATHS.DRIVING_HISTORY, (0 < this.props.driverIndex ? this.props.driverIndex + "" : ""))),
                    () => {
                        this.setState({ ...this.state, updatingStore: false });
                    });
        });
    }
    
    callbackFunctionStatus = (childData:string) => {
        switch (childData) {
            case QUOTE_QUESTIONS.YOUR_LICENSE.CURRENT_LICENSE_STATUS.SUSPENDED:
            case QUOTE_QUESTIONS.YOUR_LICENSE.CURRENT_LICENSE_STATUS.VALID_COMMERCIAL_LICENSE:
            case QUOTE_QUESTIONS.YOUR_LICENSE.CURRENT_LICENSE_STATUS.VALID_CANADIAN_LICENSE:
            case QUOTE_QUESTIONS.YOUR_LICENSE.CURRENT_LICENSE_STATUS.EXPIRED:
            case QUOTE_QUESTIONS.YOUR_LICENSE.CURRENT_LICENSE_STATUS.RESTRICTED:
                this.setState({ currentLicenseStatus : childData, visibleFirstLicense: true });
                break;
            default:
                this.setState({ currentLicenseStatus: childData, visibleFirstLicense: false });
                break;
        }
    };

    callbackFunctionLicense = (childData:string) => {
        switch (childData) {
            case QUOTE_QUESTIONS.YES_NO.YES:
                this.setState({ validLicense: childData, currentLicenseStatus: "", visibleCurrentStatus: false, visibleFirstLicense: true });
                break;
            case QUOTE_QUESTIONS.YES_NO.NO:
                this.setState({ validLicense: childData, currentLicenseStatus: "", visibleCurrentStatus: true, visibleFirstLicense: true });
                break;
        }
    };

    render() {
        return (
            <QuoteStep id={this.props.id}>
                <div className="titleArea"><h5>YOUR LICENSE</h5></div>
                <ValidatableForm hasErrors={null != this.state.errors}>
                    <Question
                        name="validLicense"
                        selected={this.callbackFunctionLicense}
                        selectedValue={this.state.validLicense}
                        error={validationUtils.getValidationErrorFor(this.state.errors, "validLicense")}
                        items={[
                            QUOTE_QUESTIONS.YES_NO.YES,
                            QUOTE_QUESTIONS.YES_NO.NO
                        ]}
                        lable="Do you have a valid U.S. license?" />

                    <Question
                        name="currentLicenseStatus"
                        selectedValue={this.state.currentLicenseStatus}
                        error={validationUtils.getValidationErrorFor(this.state.errors, "currentLicenseStatus")}
                        style={{ display: this.state.visibleCurrentStatus ? '' : 'none' }}
                        selected={this.callbackFunctionStatus}
                        items={[
                            QUOTE_QUESTIONS.YOUR_LICENSE.CURRENT_LICENSE_STATUS.MATRICULA_INTERNATIONAL_LICENSE,
                            QUOTE_QUESTIONS.YOUR_LICENSE.CURRENT_LICENSE_STATUS.EXPIRED,
                            QUOTE_QUESTIONS.YOUR_LICENSE.CURRENT_LICENSE_STATUS.REVOKED_SUSPENDED
                            //QUOTE_QUESTIONS.YOUR_LICENSE.CURRENT_LICENSE_STATUS.SUSPENDED,
                            //QUOTE_QUESTIONS.YOUR_LICENSE.CURRENT_LICENSE_STATUS.NON_LICENSED,
                            //QUOTE_QUESTIONS.YOUR_LICENSE.CURRENT_LICENSE_STATUS.PERMIT,
                            //QUOTE_QUESTIONS.YOUR_LICENSE.CURRENT_LICENSE_STATUS.VALID_COMMERCIAL_LICENSE,
                            //QUOTE_QUESTIONS.YOUR_LICENSE.CURRENT_LICENSE_STATUS.VALID_CANADIAN_LICENSE,
                            //QUOTE_QUESTIONS.YOUR_LICENSE.CURRENT_LICENSE_STATUS.OTHER_VALID_FOREIGN_LICENSE,
                            //QUOTE_QUESTIONS.YOUR_LICENSE.CURRENT_LICENSE_STATUS.EXPIRED,
                            //QUOTE_QUESTIONS.YOUR_LICENSE.CURRENT_LICENSE_STATUS.RESTRICTED,
                            //QUOTE_QUESTIONS.YOUR_LICENSE.CURRENT_LICENSE_STATUS.SURRENDERED,
                            //QUOTE_QUESTIONS.YOUR_LICENSE.CURRENT_LICENSE_STATUS.PERMANENTLY_REVOKED
                        ]}
                        lable="What's your current license status?" />

                    <div style={{ display: this.state.visibleFirstLicense ? '' : 'none' }}>
                        <ValidatableFormGroup
                            label="How old were you when you first got your license in the U.S. or Canada?"
                            maxLength={2}
                            value={this.state.licenseYears}
                            validated={null !== this.state.errors}
                            validationError={validationUtils.getValidationErrorFor(this.state.errors, "licenseYears")}
                            onChange={(e) => { this.setStateValue(e.target.value, "licenseYears") }}
                            pattern="[0-9]*"
                            inputmode= "numeric" />
                    </div>

                    {
                        //<Question
                        //    name="driverTrainingClasses"
                        //    selected={(v) => { this.setStateValue(v, "driverTrainingClasses") }}
                        //    selectedValue={this.state.driverTrainingClasses}
                        //    error={validationUtils.getValidationErrorFor(this.state.errors, "driverTrainingClasses")}
                        //    items={[
                        //        QUOTE_QUESTIONS.YES_NO.YES,
                        //        QUOTE_QUESTIONS.YES_NO.NO
                        //    ]}
                        //    lable="Have you completed any voluntary driver training classes in the past 3 years?" />
                    }
                </ValidatableForm>

                <div className="btnContainer">
                    <ButtonContinue
                        disabled={this.state.updatingStore}
                        showLoading={this.state.updatingStore}
                        onClick={this.next} />
                </div>
            </QuoteStep>
        );
    }
}

export default connect(mapDriverStepProps, getDriverStepMapDispatch(QUOTE_STEPS.YOUR_LICENSE))(YourLicense);
